<template>
  <div class="heading" :class="level">
    <Label
      v-if="label"
      class="heading__label"
      :label="label"
    />
    <component
      :is="level"
      :class="`heading__title ${title_class}`"
      v-html="cleanTitle"
    />
    <p
      v-if="subtitle"
      class="heading__span font-bold"
    >
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
import Label from '@/components/partials/Label.vue'

export default {
  name: 'Heading',
  components: {
    Label
  },
  props: {
    level: {
      type: String,
      default: 'h1'
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    title_class: {
      type: String,
      default: ''
    }
  },
  computed: {
    cleanTitle () {
      if (!this.title) {
        return ''
      }
      return this.title.replace('<p>', '').replace('</p>', '').replace('<P>', '').replace('</P>', '')
    }
  }
}
</script>

<docs>
  ```jsx
    <div>
      <heading
        label="This is a label"
        title="This is a title"
        subtitle="this is a subtitle"
        />
    </div>
  ```
</docs>

<style lang="scss">

.heading {
  padding: 0 $padding;
  margin-top: $large-space-top;
}

.heading__title {
  em {
    font-family: 'HeyAugust';
  }
}
</style>
